import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { Button } from "sprout-ui-dom";
import { Flex, Text } from "sprout-ui-primitives";
import useAppAddUserFlag from "@sprout/client-graphql/dist/mutations/useAppAddUserFlag";
import useCheckUserFlag from "@sprout/hooks/dist/useCheckUserFlag";
import { useIsWelcomePageOnboard } from "@sprout/hooks/dist/onboard";
import styled from "styled-components";
import { media } from "sprout-ui-theme";
const ExtensionCallOutWrapper = styled(Flex)`
  ${media.down("medium")} {
    display: none;
  }

  ${media.target("touch")} {
    display: none;
  }
`;
const ExtensionCallOut = ()=>{
    const flag = "EXTENSION_CALLOUT_DISMISSED";
    const doesFlagExist = useCheckUserFlag(flag);
    const [isWelcomePageOnboard] = useIsWelcomePageOnboard();
    const addUserFlag = useAppAddUserFlag();
    const handleClick = useCallback(()=>{
        addUserFlag(flag);
    }, [
        addUserFlag
    ]);
    if (!isWelcomePageOnboard || doesFlagExist) return null;
    return /*#__PURE__*/ _jsxs(ExtensionCallOutWrapper, {
        position: "fixed",
        bottom: "16px",
        right: "16px",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bg: "blue.500",
        borderRadius: "24px",
        maxWidth: "280px",
        p: 5,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                fontSize: 3,
                mb: 5,
                color: "white.100",
                children: "Get the browser extension button to save links faster"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "bright-teal",
                height: "40px",
                as: "a",
                href: "https://chrome.google.com/webstore/detail/sprout-save-button/acgadgpicnkggmbimkcefdeeendeiflf",
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: handleClick,
                children: "Install the extension"
            })
        ]
    });
};
export default ExtensionCallOut;
